const ConnectionForm = ({
  onNewLogin,
  onSavedLogins,
  showSavedLogins = true
}) =>
<div className="flex flex-wrap gap-2 w-full justify-end">
    <button
    type="button"
    className="pill-button px-4 py-2 text-sm"
    onClick={onNewLogin}>
    
      New Login
    </button>
    {showSavedLogins ?
    <button
      type="button"
      className="ghost-button px-4 py-2 text-sm"
      onClick={onSavedLogins}>
      
        Saved Logins
      </button> :
    null}
  </div>;


export default ConnectionForm;
